import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csdowhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Do While tutorial For Beginners</title>
 <meta name="description" content="C# do While tutorial for beginners. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# do While,c# do While for,c sharp do While,c# do While for loop,end for loop c#,c# exit for loop,exit while loop c#,c# continue,do While foreach c#,c# foreach do While,c# foreach continue" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-do-while" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Do-while Loop in C#</h1>
    <div className="first">
        <a href="/csharp-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">In do-while, CSharp(C#) loop will always execute at least once 
</p>


<h2 className='headings'>Syntax do-while c# loop:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">Do </span>
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-6">Statements</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">condition</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>





<h2 className='headings'>Q-Write a program for loop in Do while loop and print names Example in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-3">do while</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-6">a </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">do </span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              <span className="qwerty-3">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">a</span>
            <span className="qwerty-1"> ++</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-6">a </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-10"> 10</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}{"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"}
              <span className="qwerty-6">Hello</span>
              <span className="qwerty-4"> code </span>
              <span className="qwerty-10">Exampler</span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program Addition or increment of 2 numbers every Times in do-while loop Example in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-3">do while</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-6">a </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">do </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-6">hello</span>
              <span className="qwerty-4"> everyone </span>
              <span className="qwerty-3">"</span>
            <span className="qwerty-1">+</span>
            <span className="qwerty-6"> a</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">a</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-6">a</span>
            <span className="qwerty-1"> + </span>
            <span className="qwerty-10">2</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-6">a </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-10"> 5</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}{"\n"}
              <span className="qwerty-6">hello</span>
              <span className="qwerty-4"> everyone </span>
              <span className="qwerty-10">1 </span>
              {"\n"}
              <span className="qwerty-6">hello</span>
              <span className="qwerty-4"> everyone </span>
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-6">hello</span>
              <span className="qwerty-4"> everyone </span>
              <span className="qwerty-10">5 </span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>

<h2 className="mt-4 mh2">Increment in Do while C# loop Example</h2>




<h2 className='headings'>Q-Write a program Addition or increment of 1+ every Times in do-while loop Example in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-3">dowhile</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-6">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">do </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
            <span className="qwerty-10">"+</span>
            <span className="qwerty-6"> a</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">a </span>
            <span className="qwerty-3">++;</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-6"> a </span>
            <span className="qwerty-3">&#60; =</span>
            <span className="qwerty-10"> 10 </span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}{"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">1 </span>
              {"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">2 </span>
              {"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">4 </span>
              {"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">5 </span>
              {"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">6 </span>
              {"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">7 </span>
              {"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">8 </span>
              {"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">9 </span>
              {"\n"}
              <span className="qwerty-6">Increment</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">10</span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>

<h2 className="mt-4 mh2">Decrement in Do while c# Example</h2>



<h2 className='headings'>Q-Write a program Subtract or decrement of -1 numbers every Times in do-while loop Example in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-3">While</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-3">int </span>
            <span className="qwerty-6">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">do </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
            <span className="qwerty-10">"+</span>
            <span className="qwerty-6"> a</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">a </span>
            <span className="qwerty-3">--;</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-6"> a </span>
            <span className="qwerty-3">&#62; =</span>
            <span className="qwerty-10"> 1 </span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}{"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">10 </span>
              {"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">9 </span>
              {"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">8 </span>
              {"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">7 </span>
              {"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">6 </span>
              {"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">5 </span>
              {"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">4 </span>
              {"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">2 </span>
              {"\n"}
              <span className="qwerty-6">Decrement</span>
              <span className="qwerty-4"> No </span>
              <span className="qwerty-10">1 </span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>


  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/csharp-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csdowhile;